/* unplugin-vue-components disabled */import __unplugin_components_1 from '/home/pedrazzi/projetos/advogados/v5/src/components/social/Index.vue';
import __unplugin_components_0 from '/home/pedrazzi/projetos/advogados/v5/src/components/Breadcrumbs.vue';
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-img",
        {
          staticClass: "px-4",
          attrs: {
            height: _vm.height,
            src: "src/images/parallax/clientes.webp",
            "lazy-src": "src/images/parallax/clientes.webp",
            gradient: "to top right, rgba(0,0,0,.45), rgba(0,0,0,.2)",
            flat: "",
            dark: "",
            tile: "",
          },
        },
        [_vm._t("header")],
        2
      ),
      _vm._v(" "),
      _c(__unplugin_components_0,
        { staticClass: "rounded-0 my-3 mx-4", attrs: { items: _vm.menu } },
        [
          _c("v-spacer"),
          _vm._v(" "),
          _c(__unplugin_components_1, {
            attrs: {
              twitter: "",
              facebook: "",
              whatsapp: "",
              telegram: "",
              url: _vm.url,
              title: _vm.title,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("body"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }